import { render, staticRenderFns } from "./Ranking3.vue?vue&type=template&id=201a890e&scoped=true"
import script from "./Ranking3.vue?vue&type=script&lang=js"
export * from "./Ranking3.vue?vue&type=script&lang=js"
import style0 from "./Ranking3.vue?vue&type=style&index=0&id=201a890e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201a890e",
  null
  
)

export default component.exports